class DlFaqVideoDetial extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.container = this.querySelector('.dl-faq-video-detial-container');
        this.video = this.querySelector('video');
        this.btn = this.querySelector('.dl-faq-video-image svg');

        this.bindEvent();
    }

    bindEvent() {
        this.btn.addEventListener('click', this.play.bind(this));
    }

    play() {
        this.container.classList.add('dl-play');
        this.video.play();
    }
}

customElements.define('dl-faq-video-detial', DlFaqVideoDetial);